import { Await } from "react-router";
import CustomError from "@components/Error/CustomError";
import { GlobalContext } from "@pages/Global/utils/types";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import GlobalPageContent from "./GlobalPageContent";

export default function GlobalPage(): React.ReactElement {
  const { context } =
    useRouteContext<TRouteWithRedirect<GlobalContext, string>>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (context && !context.payload) {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }: GlobalContext) => {
        if (kind === "static") return <GlobalPageContent data={data} />;

        // Default error page.
        return <CustomError statusCode={HttpStatusCode.NotFound} />;
      }}
    </Await>
  );
}
